import React from 'react'
import { Background, CrossShadow, DesktopView, Image, Object, Text, View, Overlay, MsInfo, Blur, Button } from '../assets/styles'
import Watch from '../assets/img/watch.png'
import WatchScape from '../assets/img/watch-landscape.png'
import John from '../assets/img/john.jpg'
import Mark from '../assets/img/mark.jpg'
import She from '../assets/img/she.jpg'
import Land1 from '../assets/img/landscape1.png'
import Land2 from '../assets/img/landscape2.png'
import Sky from '../assets/img/backgrounds/sky.jpg'

const Interface = () => {
  const Break = 'br'
  return (
    <DesktopView className='Activity'>
        <View className='alps'>
        <Background bgImg={Sky}/>
        <Image src={Land2} className={'land2'}/>
        <Object className={'backdrop-touch'}>
            <Text size={10} className='bold backdrop-col'>
              RESI<Text className='bold stroke-0'>STANT</Text>
            </Text>
        </Object>
        <Image src={Land1} className={'land1'}/>
        <Image src={Watch} size={20} className='Watch'/>
        <MsInfo left={2} top={3.5} zIndex={99} textAlign={'left'} className='left-slide-first slide'>
          <Text size={3.5} className='bold text-outline'>
          CON<Text className='bold stroke-0'>CEPT</Text>
          </Text><Break/>
          <Text className={'primary-text'} size={1}>
            This model of seires watch has been designed by Apple <Break/>
            ultra-modern and industrial take in wearable technology <Break/>
            that merges aesthetics to achieve a stylish piece of  <Break/>
            equipment.
          </Text><Break/>
          <Blur blur={.5} mt={.5} background={'#ffffff25'} radius={.5} py={.5} px={1} display={'flex'} float={'left'}>
            <Object py={.9} px={.9} float={'left'} radius={3} bgImg={John}></Object>
            <Object py={.9} px={.9} float={'left'} radius={3} ml={-.7} shadow={'-3px 0 10px 0 #00000099'} zIndex={1} bgImg={Mark}></Object>
            <Object py={.9} px={.9} float={'left'} radius={3} ml={-.7} shadow={'-3px 0 10px 0 #00000099'} zIndex={1} bgImg={She}></Object>
            <Object float={'left'} radius={3} ml={1}>
              <Text className='primary-text'>+10k more</Text>
            </Object>
          </Blur>
        </MsInfo>

        <MsInfo left={2} bottom={3.5} zIndex={99} textAlign={'left'} className='left-slide-last slide'>
          <Object py={2} px={6} radius={.6} blur={1} background={'#ffffff30'}>
          <Image src={Watch} size={7} scale={1.1}/>
          </Object>
        </MsInfo>
        
        <MsInfo right={2} bottom={5} zIndex={99} textAlign={'right'} className='right-slide slide'>
          <Blur blur={.5} background={'#f4a17e24'} radius={.5} py={.2} px={1} float={'right'}>
            <Text size={2}>$740.00</Text>
          </Blur><Break/>
          <Text size={3.5} className='bold'>
            CON<Text className='bold text-outline'>CEPT</Text>
          </Text><Break/>
          <Text className={'primary-text'} size={1}>
            The wearable follows the designer's experience <Break/>
            using the Apple watch before switching to the series. <Break/>
            It features a hybrid design that includes physical <Break/>
            controls alongside smart features. The wearable thus <Break/>
            features a squre case with industrial accents like <Break/>
            visible screws. While vents on the side indicates <Break/>
            the smartwatch has a built-in speaker <Break/> and/or microphone.
          </Text>
        </MsInfo>
        </View>
        <View>
        <CrossShadow className={'cross-shadow'}/>
            <View className={'main'}>
            <Background bgImg={Sky}/>
            <Image src={Land2} className={'land-view2'}/>
            <Image src={Land1} className={'land-view1'}/>
            <Overlay>
            <Break/>
            <Text className={'col-orange bold'} size={5}>INDUSTRIAL</Text><Break/>
            <Text className={'text-outline bold'} size={7}>DESIGN</Text><Break/>
            <Break/>
            <Object display={'flex'} align={'center'} justify={'center'}>
            <Image src={WatchScape} position={'absolute'} size={55} className={'watch-landscape'}/>
            </Object>
            <Object display={'flex'} align={'center'} justify={'center'}>
            <Button py={.8} display={'flex'} align={'center'} justify={'center'} px={2} radius={.5} position={'absolute'} cursor={'pointer'} bottom={8.5}>
              <Text size={1.4} position={'absolute'} className='bold col-black'>ORDER NOW</Text>
              <Text size={1} className='op-0'>ORDER NOW</Text>
            </Button>
            </Object>
            </Overlay>
            </View>
        </View>
    </DesktopView>
  )
}

export default Interface